import { useConfigStore } from '../stores/config'

export const useCdnImages = () => {
  const configStore = useConfigStore()

  const cdnImageUrl = (path: string): string =>
    `${configStore.rsConfig.cdnUri}${path}?v=${process.env.RS_VERSION}`

  return { cdnImageUrl }
}
